<template>
  <div class="form-group">
    <f-label :label="label" :id="id" :required="required" />
    <slot />
    <f-hint :hint="hint" />
    <transition name="f-tooltip">
      <div class="invalid-tooltip" v-if="error" :key="error">{{ error }}</div>
      <div class="invalid-tooltip" v-else-if="tooltip">{{ tooltip }}</div>
    </transition>
  </div>
</template>

<script>
import FLabel from './FLabel'
import FHint from './FHint'

export default {
  name: 'FGroup',
  components: { FLabel, FHint },
  props: {
    label: String,
    id: String,
    required: Boolean,
    tooltip: String,
    hint: String,
    error: { type: String, default: null }
  }
}
</script>

<style scoped>
.f-tooltip-enter-active,
.f-tooltip-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.f-tooltip-enter,
.f-tooltip-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>



// WEBPACK FOOTER //
// src/components/FormFields/Base/FGroup.vue